import React from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from 'services/ThomasAuth/AuthContext';
import { ExitIcon } from 'views/components/Icons/EditIcons';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
interface IState {
  toggleInventory: boolean;
  isAdminUserAuth: boolean;
  siteNavItems: any;
}
class SiteAside extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);

    const siteNavItems = [
      {
        route: '/advertisers',
        name: 'Accounts Home',
        isActive: false,
        checkAccess: CONSTANTS.ACCESS_CONTROL.ALL_ACCESS
      },
      {
        route: '/advertisers/pvs',
        name: 'PVS',
        isSubNavActive: true,
        isActive: false,
        checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS,
        children: [
          {
            route: '/inventory/pvs',
            name: 'Inventory',
            isActive: false,
            checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
          }
        ]
      },
      {
        route: '/advertisers/points',
        name: 'Points',
        isSubNavActive: true,
        isActive: false,
        checkAccess: CONSTANTS.ACCESS_CONTROL.ALL_ACCESS,
        children: [
          {
            route: '/templates',
            name: 'Configurations',
            isActive: false,
            checkAccess: CONSTANTS.ACCESS_CONTROL.ALL_ACCESS
          }
          // {
          //   route: () => <a href={`${props.auth.rankAuthPath()}`}>New Configuration</a>,
          //   name: 'New Configuration',
          //   isActive: false,
          //   checkAccess: ACCESS_CONTROL.ALL_ACCESS
          // }
        ]
      },
      {
        route: '/fulfillments/audit',
        name: 'Pending Campaigns',
        isActive: false,
        checkAccess: CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
      }
    ];

    siteNavItems.map(navItem => {
      if (navItem.route === props.location.pathname) {
        navItem.isActive = true;
      }
      if (props.location.pathname === '/home') {
        if (navItem.route === '/advertisers') {
          navItem.isActive = true;
        }
      }
    });

    this.state = {
      toggleInventory: false,
      isAdminUserAuth: false,
      siteNavItems: siteNavItems
    };
  }

  static contextType = AuthContext;

  setIsActiveFalse = navItem => {
    navItem.isActive = false;
    if (navItem.hasChildren) {
      navItem.children.map(subNavItem => {
        subNavItem.isActive = false;
      });
    } else {
      navItem.isActive = false;
    }
  };

  toggleNav = (nav, subNav = null) => {
    //if the user clicks on a nav item with children, the nav children should appear.
    const { siteNavItems } = this.state;
    siteNavItems.map(this.setIsActiveFalse);

    if (subNav) {
      siteNavItems.map(navItem => {
        if (navItem.children) {
          navItem.children.map(subNavItem => {
            if (subNavItem === subNav) {
              subNavItem.isActive = true;
            }
          });
        }
      });
    } else {
      siteNavItems.map(navItem => {
        if (navItem === nav) {
          navItem.isActive = true;
        }
      });
    }
    this.setState({
      siteNavItems
    });
  };

  toggleSubNav = nav => {
    const { siteNavItems } = this.state;
    siteNavItems.map(navItem => {
      if (navItem.name === nav.name) {
        navItem.isSubNavActive = !navItem.isSubNavActive;
      }
    });
    this.setState({
      siteNavItems: siteNavItems
    });
  };

  render() {
    const { siteNavItems } = this.state;
    const { isActive } = this.props;
    const { isAdminUserAuth } = this.props;
    return (
      <aside className={`site-aside ${isActive}`}>
        <nav className="side-nav">
          <ul className="site-nav--side-nav__level-1">
            {siteNavItems.map((nav, i) => {
              if (
                !isAdminUserAuth &&
                nav.checkAccess == CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
              ) {
                return '';
              }
              if (typeof nav.route === 'function') {
                return (
                  <li
                    key={`${nav.name} ${i}`}
                    className={`site-nav--side-nav__li-l1 ${nav.isActive ? `active` : ''}`}
                    onClick={() => this.toggleNav(nav)}
                  />
                );
              }
              if (nav.children && nav.route) {
                return (
                  <React.Fragment key={`${nav.name} ${i}`}>
                    <li
                      className={`site-nav--side-nav__li-l1 ${`menu-item-has-children`} ${
                        nav.isActive ? `active` : ''
                      }`}
                      onClick={() => this.toggleNav(nav)}
                    >
                      <NavLink to={`${nav.route}`}>{nav.name}</NavLink>
                      <ul
                        className={`site-nav--side-nav__level-2 ${
                          nav.isSubNavActive ? `active` : ''
                        }`}
                      >
                        {nav.children.map(subnav => {
                          if (
                            !isAdminUserAuth &&
                            subnav.checkAccess == CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS
                          ) {
                            return '';
                          }
                          if (typeof subnav.route === 'function') {
                            return (
                              <li
                                key={`${nav.name} ${i}`}
                                className={`site-nav--side-nav__li-l2 ${
                                  nav.isActive ? `active` : ''
                                }`}
                                onClick={() => this.toggleNav(nav)}
                              >
                                {subnav.route()}
                              </li>
                            );
                          }
                          return (
                            <li
                              key={`${subnav.name} ${i}`}
                              className={`site-nav--side-nav__li-l2 ${
                                subnav.isActive ? `active` : ''
                              }`}
                            >
                              <NavLink
                                to={`${subnav.route}`}
                                onClick={() => this.toggleNav(nav, subnav)}
                              >
                                {subnav.name}
                              </NavLink>
                            </li>
                          );
                        })}
                      </ul>
                      <span
                        className={`m-subnav-arrow ${nav.isSubNavActive ? `active` : ''}`}
                        onClick={() => this.toggleSubNav(nav)}
                      />
                    </li>
                  </React.Fragment>
                );
              } else {
                return (
                  <li
                    key={`${nav.name} ${i}`}
                    className={`site-nav--side-nav__li-l1 ${nav.isActive ? `active` : ''}`}
                    onClick={() => this.toggleNav(nav)}
                  >
                    <NavLink to={`${nav.route}`}>{nav.name}</NavLink>
                  </li>
                );
              }
            })}
            <li key={`logout button`} className={`site-nav--side-nav__li-l1`} onClick={() => {}}>
              <NavLink to="/logout">
                <ExitIcon /> Logout
              </NavLink>
            </li>
          </ul>
        </nav>
      </aside>
    );
  }
}

export default SiteAside;
